import { RequiredActionOutput } from '@coverright/data-access/types/enrollment';
import { useState } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { Box, Collapse, Divider, Stack, Typography } from '@mui/material';
import { actionTypeMap } from './required-actions/action-type-map';
import * as React from 'react';
import { NoData } from '../../shared';

export const RequiredActionsList = ({
  actions,
  onResolved,
}: {
  actions: RequiredActionOutput[];
  onResolved: (id: string) => void;
}) => {
  const [resolved, setResolved] = useState<string[]>([]);

  const handleResolved = (id: string) => {
    setResolved((prev) => [...prev, id]);
    setTimeout(() => {
      onResolved(id);
      setResolved((prev) => prev.filter((n) => n !== id));
    }, 500);
  };

  return (
    <Stack gap={2} flex={1}>
      <Stack gap={1}>
        <Typography variant={'subtitle1'}>Required actions</Typography>
        <Divider />
      </Stack>
      {!actions.length ? (
        <Box>
          <NoData>{'No actions'}</NoData>
        </Box>
      ) : (
        <OverlayScrollbarsComponent
          style={{ height: 'calc(100vh - 230px)', paddingRight: 16 }}
          options={{ paddingAbsolute: true }}
          defer
        >
          <Stack>
            {actions.map((n) => {
              const Component =
                actionTypeMap[n.type as keyof typeof actionTypeMap];
              if (!Component) return null;
              return (
                <Collapse key={n.id} in={!resolved.includes(n.id)}>
                  <Component item={n} onResolved={() => handleResolved(n.id)} />
                </Collapse>
              );
            })}
          </Stack>
        </OverlayScrollbarsComponent>
      )}
    </Stack>
  );
};
